module.exports = __webpack_public_path__ + "static/img/step2.4d8128a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step2.png
// module id = 2SFc
// module chunks = 1